import React from 'react';
import { useQuery } from '@edreamsodigeo/frontend-api-client';
import { useLogFrontendApiError } from '@edreamsodigeo/frontend-core';
import { AvailableCabinBagsContext } from 'context';
import { GET_CABIN_BAGS_QUERY } from './AvailableCabinBagsProvider.query';
import { useShoppingBundleInfo } from 'src/hooks/useShoppingBundleInfo';

export const AvailableCabinBagsProvider = ({ children }) => {
  const shoppingInfo = useShoppingBundleInfo();
  const bookingId = shoppingInfo?.shoppingId;

  const response = useQuery(GET_CABIN_BAGS_QUERY, {
    variables: {
      bookingId,
    },
  });

  useLogFrontendApiError(response);

  return (
    <AvailableCabinBagsContext.Provider value={response}>
      {children}
    </AvailableCabinBagsContext.Provider>
  );
};
